import {
  type ColumnDef,
  type RowData,
  createColumnHelper,
  metaHelper,
  rowSelectionFeature,
  rowSortingFeature,
  tableFeatures,
} from "@tanstack/react-table";

import type { DataTableColumnFilterSpec } from "./DataTable.types";

export type DataTableColumnMeta = {
  width?: string;
  minWidth?: string;
  maxWidth?: string;
  truncate?: boolean;
  filter?: DataTableColumnFilterSpec;
};

export const dataTableFeatures = tableFeatures({
  rowSelectionFeature,
  rowSortingFeature,
  columnMeta: metaHelper<DataTableColumnMeta>(),
});

export type DataTableColumnDef<
  TData extends RowData,
  TValue = unknown,
> = ColumnDef<typeof dataTableFeatures, TData, TValue>;

export function createDataTableColumnHelper<TData extends RowData>() {
  return createColumnHelper<typeof dataTableFeatures, TData>();
}
